import { render, staticRenderFns } from "./AssignmentDutiesWithCleanCode.vue?vue&type=template&id=23dc327a&"
import script from "./AssignmentDutiesWithCleanCode.vue?vue&type=script&lang=js&"
export * from "./AssignmentDutiesWithCleanCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports